import { render, staticRenderFns } from "./ShopGoods.vue?vue&type=template&id=473a35f2"
import script from "./ShopGoods.vue?vue&type=script&lang=js"
export * from "./ShopGoods.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports